<template>
  <div>
    <b-form-group
        :label-for="name+ (listIndex != -1?('_'+(listIndex+1)):'')"
        :label="displayLabel?capitalize($tc(name)):null"
        class="w-100"
    >
      <v-select
          :id="name+ (listIndex != -1?('_'+(listIndex+1)):'')"
          :multiple="multiple"
          v-model="localModel"
          :label="label"
          :options="list"
          :reduce="label => label.id"
          :placeholder="$tc('ChooseExpense')"
          :selectable="(option) => !option.disabled"
          :clearable="clearable"
          :disabled="disabled"
          :append-to-body="appendToBody"
          :filter="filterBankOperation"
          class="w-100"
      >
        <template v-slot:option="option">
          <div class="d-flex">
            <div class="w-100 text-truncate">
              {{ option.wording }}
            </div>
            <div
                class="text-right"
                :class="option._balance>0?'text-success':'text-danger'"
            >
              {{ currency(option._balance) }}
            </div>
          </div>
          <div class="d-flex font-italic">
            <div>
              <small>{{ option.operationDate|moment('L') }}</small>
            </div>
            <div class="w-100 text-right text-truncate">
              <small v-if="option.company != null">{{ option.company._display }}</small>
            </div>
          </div>
        </template>

      </v-select>

    </b-form-group>
  </div>
</template>

<script>
import { ref, computed, watch } from '@vue/composition-api'
import { capitalize, currency } from '../../../utils/filter'
import { comparableString } from '../../../utils/utils'

import vSelect from 'vue-select'
import store from '../../../store'
import moment from 'moment'

export default {
  components: {
    vSelect
  },
  props: {
    bankAccounts: {
      type: Array,
      default: () => []
    },
    model: {
      required: true
    },
    multiple: {
      type: Boolean,
      default: false
    },
    onlyNotCompletelyPaid: {
      type: Boolean,
      default: false
    },
    displayLabel: {
      type: Boolean,
      default: true
    },
    clearable: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    listIndex: {
      type: Number,
      default: -1
    },
    appendToBody: {
      type: Boolean,
      default: true
    }
  },
  setup (props, { emit }) {
    // ------------------------------------------------
    // Data
    // ------------------------------------------------
    const localModel = ref(props.model)
    const name = ref('bankOperationConnection')
    const label = ref('_display')

    // ------------------------------------------------
    // Computed
    // ------------------------------------------------
    const list = computed(() => {
      let bankOperations = []
      props.bankAccounts.forEach(ba => {
        ba.bankOperations.forEach(bo => {
          if (bo._isAttached == false) {
            bankOperations.push(bo)
          }
        })
      })

      bankOperations.sort((a, b) => {return new Date(b.operationDate) - new Date(a.operationDate)})

      return bankOperations
    })

    // ------------------------------------------------
    // Watch
    // ------------------------------------------------
    watch(localModel, () => {
      emit('update:model', localModel.value)
      emit('input', localModel.value)
    })

    // ------------------------------------------------
    // Methods
    // ------------------------------------------------
    const filterBankOperation = (options, search) => {
      return options.filter(bo => {
        return (
            compare(comparableString(bo.wording), comparableString(search)) ||
            compare(comparableString(bo._balance), comparableString(search)) ||
            compare(comparableString(moment(bo.operationDate).format('L')), comparableString(search)) ||
            (
                bo.company != null &&
                '_display' in bo.company &&
                compare(comparableString(bo.company._display), comparableString(search))
            )
        )
      })
    }

    const compare = (label, search) => {
      return (label || '').toLocaleLowerCase().indexOf(search.toLocaleLowerCase()) > -1
    }

    // ------------------------------------------------
    // Mounted
    // ------------------------------------------------

    // ------------------------------------------------
    // Setup
    // ------------------------------------------------
    return {
      // Components
      capitalize,
      currency,

      // Data
      localModel,
      name,
      label,

      // Computed
      list,

      // Methods
      filterBankOperation,
    }
  },
  data () {
    return {}
  },
  computed: {},
  watch: {},
  methods: {},
  mounted () {
  },
  created () {
  }
}
</script>

<style lang="scss">

</style>